/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const InfographicsFragment = {
  Infographics: gql`
    fragment InfographicsQuery on infographics_Entry {
      infographicImage {
        url
        ... on images_Asset {
          altText
          title
        }
      }
      longDescription
      typeHandle
    }
  `,
};
